import { RdsTextItem } from './text-item.model';

export interface RdsTextLink extends RdsTextItem {
  url: string;
  target?: '_blank' | '_self';
}

export function instanceOfRdsTextLink(something: any): something is RdsTextLink {
  return !!something && !!something.url;
}
